import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { UploadFileComponent } from '../../helpers/upload-file/upload-file.component';

@Component({
    selector: 'app-developer-import-upload',
    templateUrl: './developer-import-upload.component.html',
    styleUrls: ['./developer-import-upload.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [UploadFileComponent]
})
export class DeveloperImportUploadComponent {
  @Output() goCompare = new EventEmitter<File>();

  constructor() { }

  onFileChange(file: File): void {
    if ((file?.type === 'application/xml') || (file?.type === 'text/xml')) {
      this.goCompare.emit(file);
    }
  }
}
